export const DefaultIconStyle = { height: 20, width: 20 };
export const SmallIconStyle = { height: 10, width: 10 };
